import { BaseError } from "./base.js";
export class InvalidSignerTypeError extends BaseError {
    constructor(signerType) {
        super([
            "Invalid signer type parameter passed to SmartAccountSigner.",
            signerType ?? "A signerType must be provided.",
        ].join("\n"));
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSignerTypeError"
        });
    }
}
//# sourceMappingURL=signer.js.map